module.exports = __webpack_public_path__ + "static/media/edificios.96730feb.svg";